<template>
  <div class="sm-live-reception__main-item">
    <div class="sm-live-reception__main-item-left">
      <div class="sm-live-reception__main-item-left-title">
        <h4>{{item.name}}</h4>
        <p 
          v-if="isCurrent"
          class="sm-txt-upper sm-txt-strong"
        >Current plan</p>
      </div>
      <p class="sm-live-reception__main-item-left-descr">{{item.description}}</p>
      <div class="sm-live-reception__main-item-left-footer">
        <span>
          <strong class="sm-sys">{{item.minutes}}</strong>
          <span> live answering calls</span>
        </span>
        <span v-if="showCalls">
          <strong class="sm-sys">{{item.average_calls}}</strong>
          <span> average calls per month</span>
        </span>
      </div>
    </div>
    <div class="sm-live-reception__main-item-right">
      <div 
        class="sm-live-reception__main-item-right-price"
        :class="{
          'disabled': isCurrent && !showSwitch
        }"
      >
        <strong>{{formatPrice(item.price, 0)}}</strong>
        <span class="sm-small disabled">/month</span>
      </div>
      <div
        v-if="!isCurrent || showSwitch" 
        class="sm-live-reception__main-item-right-btns"
      >
        <template v-if="isCurrent">
          <btn-block
            v-if="canSwitch"
            :type="'small'"
            :text="'Switch plan'"
            :class="'white'"
            :icon="'icon-switch'"
            @click="$emit('switch')"
          />
          <btn-block
            :type="'small'"
            :text="'Cancel plan'"
            :class="'white error'"
            @click="$emit('cancel')"
          />
        </template>
        <btn-block
          v-else
          :type="'small'"
          :text="subscribeText"
          @click="$emit('subscribe', item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {FormatPrice} from '@/utils/general-data';

export default {
  name: 'live-receptionist-item',
  props: {
    item: {
      type: Object,
      required: true
    },
    isCurrent: {
      type: Boolean,
      default: false
    },
    showCalls: {
      type: Boolean,
      default: false
    },
    showSwitch: {
      type: Boolean,
      default: false
    },
    canSwitch: {
      type: Boolean,
      default: false
    },
    subscribeText: {
      type: String,
      default: 'Subscribe'
    }
  },
  methods: {
    formatPrice: FormatPrice
  }
}
</script>